import { siteApiSlice } from "../../../../app/siteApiSlice";
import { WriterModel } from "../../shared/Models";

export interface PromptUsageFilteredByWriterViewModel extends WriterModel {
	courseId: number;
	prompts: PromptUsage[];
	constructedResponsePrompts: PromptUsage[];
}

export interface PromptUsage {
	promptId: number;
	promptName: string;
	essayId: number;
	lastUsedDate: string;
	draftCount: number;
	developmentOfIdeas?: number;
	organization?: number;
	style?: number;
	wordChoice?: number;
	sentenceStructure?: number;
	conventions?: number;
	totalScore?: number;
}

export const reportsApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		promptReport: build.query<
			PromptUsageFilteredByWriterViewModel,
			{ writerId?: number; courseId?: number }
		>({
			query: (arg) => {
				const { writerId, courseId } = arg;
				return {
					url: `/prompt-report`,
					params: { writerId, courseId },
				};
			},
			providesTags: ["WritingHistory", "CurrentCourse"],
		}),
	}),
});

export const { usePromptReportQuery } = reportsApiSlice;
